import { useContext, useEffect, useState } from "react";
import globalContext from '../context/context'

function CartTimer({time}) {

    const [timer, setTimer] = useState(0);
    const { resetCart } = useContext(globalContext);

    const calculateCartTime = () => {
        const oday = new Date(time);
        oday.setDate(oday.getDate() + 1);
        setTimer ( Math.floor((oday - new Date()) / 3600000));
    }

    useEffect(() => {
        const inter = setInterval(calculateCartTime, 1000);

        return () => {
            clearInterval(inter);
        }
    }, [])

    useEffect(() => {
        if(timer < -1){
            resetCart()
        }
    }, [timer])

    if(timer < -1){
        return ;
    }

    return (<small style={{fontSize: '10px', display: 'inline-block', marginLeft: '10px'}}>It is still available for {timer} hours</small>)

}

export default CartTimer;
